import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { ExcludedFirm } from "./_types";

interface Props {
  excluded: ExcludedFirm[];
}

export default function ExcludedPanel({ excluded }: Props) {
  const [open, setOpen] = useState(false);

  if (excluded.length === 0) return null;

  return (
    <div className="mt-4 border border-gray-100 rounded-lg overflow-hidden">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-4 py-2.5 bg-gray-50 text-left"
      >
        <span className="text-xs font-medium text-gray-500">
          {excluded.length} firm{excluded.length !== 1 ? "s" : ""} excluded by intelligence rules
        </span>
        {open ? <ChevronUp className="w-3.5 h-3.5 text-gray-400" /> : <ChevronDown className="w-3.5 h-3.5 text-gray-400" />}
      </button>

      {open && (
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-gray-100 text-gray-400">
              <th className="text-left px-4 py-1.5 font-medium">Contact</th>
              <th className="text-left px-4 py-1.5 font-medium">Firm</th>
              <th className="text-left px-4 py-1.5 font-medium">Reason</th>
            </tr>
          </thead>
          <tbody>
            {excluded.map((e, i) => (
              <tr key={i} className="border-b border-gray-50 last:border-0 bg-white">
                <td className="px-4 py-1.5 text-gray-500">{e.contact_name}</td>
                <td className="px-4 py-1.5 text-gray-700">{e.firm_name}</td>
                <td className="px-4 py-1.5 text-amber-600">{e.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
